'use strict';

angular.module('app.influencerGroupCondition')

.directive('influencerGroupConditionDirective', function () {
        return {
        	restrict: "EA",
        	replace: true,
        	scope: {
	            conditionItem: "=",
	            conditionListObject: "="
	        },
            controller: 'influencerGroupConditionCtrl',
            templateUrl: 'app/influencerGroup/influencerGroupCondition/influencerGroupCondition.html?app_v=deployDate',
            link: function(scope, element, attrs) {
	            scope.element = element;
	            scope.initTagit();
	        }
        };
})
